export class UserUpdateResult {
  user?: any;
  message?: string;
  success: boolean;
}
